import React, { Component } from 'react'
import {
  Layout,
  Typography,
  Button,
  Space,
  Empty,
  Input,
  Select,
  Notification,
  Divider,
  Upload,
  Message
} from '@arco-design/web-react'
import Title from 'components/tltle'
import { IconPlus } from '@arco-design/web-react/icon'
import Emptydata_img from 'asserts/Emptydata_img.svg'
import Generating_img from 'asserts/Generating_img.gif'
import errorIcon from 'asserts/error_icon.svg'
import {
  getApiInfo,
  getRequest,
  putmodelversion,
  putapp,
  check_resource,
  resumesMatch,
  aigcUpload,
  getAuthorizationToken,
  getAuthorizationCode,
  newGetappList
} from 'api/apis'
import history from 'common/utils/history'
import { CreateLink } from 'common/utils/business'
import { debounce, b2ValueUnit } from 'common/utils'
import copy from 'copy-to-clipboard'
import { sourceCancelClass } from 'api/cancel-request'
import UpgradeTips from 'components/UpgradeTips'
import upload from 'api/uploads'
import { BosClient } from '@baiducloud/sdk'
import $ from 'jquery'
import './emotionClass.scss'
const Sider = Layout.Sider
const Content = Layout.Content
const Option = Select.Option
const TextArea = Input.TextArea
const COLORS_CUSTOM = [
  '#DC2EF8',
  '#2049FF',
  '#00C7FF',
  '#FF8700',
  '#7FCA00',
  '#57DBD4',
  '#B18533',
  '#FF3D9F',
  '#A968FF',
  '#D2CD34',
  '#0FC6C2',
  '#F53F3F',
  '#7816FF',
  '#1d5ae6',
  '#319227',
  '#a6d8ff',
  '#423535',
  '#16efff',
  '#4916ff',
  '#16ffa3',
  '#ca1364',
  '#8a1114',
  '#538a11',
  '#b6ce13',
  '#ce6d13',
  '#fc6220'
]
// 封装组件
class EmotionClass extends Component {
  constructor(props) {
    super(props)
    this.state = {
      no_data: false,
      optionVlue: '',
      TextAreaValue: '',
      jobTitle: '',
      versions: [],
      ParagraphContinuation: [],
      ContinuationLoding: false,
      record: JSON.parse(localStorage.getItem('record')),
      apiInfo: {
        model_id: ''
      },
      number: 6,
      requestMsg: '',
      requestMsgText: '您还未输入文段或上传简历',
      input_describe: '请输入岗位描述',
      prompt: '',
      visibleUpgrade: false,
      upgradetips: null,
      jsonData: null,
      fileList: [],
      saasToken: '',
      iframeUrl:
        process.env.REACT_APP_ENV === 'development'
          ? 'https://test.www.yoojober.com'
          : 'https://www.yoojober.com',
      chatpptSrc: '',
      attachment: [
        'https://file.static.yoojober.cn/aigc/users/resumes/2025-02/67bd6f46f2dc5.pdf'
      ],
      emotionData: [],
      identity: JSON.parse(localStorage.getItem('userinfo'))
        ? JSON.parse(localStorage.getItem('userinfo')).group_permission
        : ''
    }
    this.isPhoneLegal = debounce(this.isPhoneLegal, 1000)
    this.isputapp = debounce(this.isputapp, 1000)
  }
  componentDidMount() {
    this.getApiInfo()
    window.addEventListener('resize', this.handleResize)
    setTimeout(() => {
      this.handleResize()
    }, 300)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
  handleResize = () => {
    var winHeight = 0
    if (window.innerHeight) {
      winHeight = window.innerHeight
    } else if (document.body && document.body.clientHeight) {
      winHeight = document.body.clientHeight
    }
    if (document.documentElement && document.documentElement.clientHeight) {
      winHeight = document.documentElement.clientHeight
    }
    let layoutHeaders_h = $('#layoutHeaders').innerHeight()
    if (layoutHeaders_h > winHeight) {
      layoutHeaders_h = 64
    }
    let height =
      winHeight -
      layoutHeaders_h -
      document.getElementById('renderHeaders').clientHeight -
      77

    document.getElementById('layout_id').style.height = height + 'px'
    document.getElementById('globalModleBox').style.height = height - 201 + 'px'
    $('.globalModle-left').css({
      height: $('#layout_id').height() - 80,
      overflowY: 'auto'
    })

    if (document.getElementById('continuation')) {
      let height2 =
        document.getElementById('layout_id').clientHeight -
        document.getElementById('result_title').clientHeight -
        document.getElementById('IconSynbtn').clientHeight
      document.getElementById('continuation').style.height =
        height2 - 110 + 'px'
    }
  }
  putmodelversion(optionVlue) {
    let params = {
      id: optionVlue
    }
    sourceCancelClass()
    this.setState({
      ContinuationLoding: true,
      requestMsg: ''
    })
    putmodelversion(params).then((res) => {
      if (res.code === 200) {
        this.isPhoneLegal()
      } else {
        this.setState({
          ParagraphContinuation: null,
          ContinuationLoding: false,
          requestMsg: '',
          requestMsgText: '模型版本激活失败',
          loading: false
        })
      }
    })
  }
  getApiInfo() {
    let params = {
      id: this.state.record.show_id
    }
    newGetappList(params).then((res) => {
      if (res.code === 200) {
        let list = res.data
        localStorage.setItem('BearerToen', res.data.token)
        this.getUserCode()
        if (res.data.model_params) {
          history.push('/myapp/enteringGinseng')
          history.go()
        } else {
          this.setState({
            apiInfo: list
          })
          // document.title = list.app_name
        }
      } else {
      }
    })
  }
  onsetPosition(value) {
    this.setState({
      optionVlue: value
    })
    this.putmodelversion(value)
  }
  onTextArea(value) {
    this.setState({
      TextAreaValue: value
    })
    // this.isPhoneLegal()
  }
  onTitle(value) {
    this.setState({
      jobTitle: value
    })
  }
  isPhoneLegal = () => {
    this.setState({
      ContinuationLoding: true,
      requestMsg: ''
    })
    sourceCancelClass()
    this.setRequest()
  }
  ChangeAbatch() {
    sourceCancelClass()
    setTimeout(() => {
      this.setRequest()
    }, 500)
  }
  setRequest() {
    // if (this.state.TextAreaValue.length < 0) {
    //   this.setState({
    //     ParagraphContinuation: null,
    //     ContinuationLoding: false,
    //     requestMsg: '',
    //     requestMsgText: '您还未输入文段',
    //   })
    // } else {
    this.getCheckResource()
    // }
  }

  sendRequest() {
    let params = {
      // app_id: this.state.record.id,
      resume_url: this.state.attachment[0],
      job_title: this.state.jobTitle,
      job_desc: this.state.TextAreaValue
    }

    // if (this.state.optionVlue) {
    //   params.version_id = this.state.optionVlue b2025022-6101-521b-37b4-37202e2b6665
    // }

    resumesMatch(params).then((res) => {
      const code = [400, 3003, 204]
      if (res.code === 200) {
        let list = res.data
        this.setState({
          jsonData: list,
          ParagraphContinuation: [1, 2],
          ContinuationLoding: false,
          requestMsg: '',
          chatpptSrc:
            this.state.iframeUrl +
            '/ai-detect-match-saas.html?&urlKey=saas&token=' +
            this.state.saasToken +
            '&coId=' +
            list.id
        })
        this.handleResize()
      } else if (code.includes(res.code)) {
        this.setState({
          ParagraphContinuation: null,
          ContinuationLoding: false,
          requestMsg: '',
          requestMsgText: res.msg
        })
      } else {
        this.setState({
          ParagraphContinuation: null,
          ContinuationLoding: false,
          requestMsg: 'error',
          requestMsgText: res.msg
        })
      }
    })
  }
  getCheckResource() {
    let params = { model_capability: this.state.apiInfo?.model_capability }
    let PACKAGES = ['PACKAGE_FINISH', 'PACKAGE_EXPIRED']
    // http://test.saas.file.yoo-ai.com/20250103/f2025010-3170-2286-aadd-541d2e5320bf.pdf
    // check_resource(params).then((res) => {
    //   if (res.code === 200) {
    //     if (res.data) {
    //       let new_upgradetips = res.data
    //       new_upgradetips.model_capability = params.model_capability
    //       this.setState({
    //         upgradetips: new_upgradetips,
    //       })
    //       if (PACKAGES[new_upgradetips.notice_type]) {
    //         Notification.warning({ content: new_upgradetips.message })
    //       } else {
    //         setTimeout(() => {
    //           this.setState({
    //             visibleUpgrade: true,
    //           })
    //         }, 100)
    //       }
    //     }
    if (this.state.attachment.length == 0) {
      Notification.warning({ content: '请上传简历!' })
      return
    }
    if (!this.state.jobTitle) {
      Notification.warning({ content: '请填写岗位名称!' })
      return
    }
    if (!this.state.TextAreaValue) {
      Notification.warning({ content: '请填写岗位描述!' })
      return
    }
    this.setState({
      ContinuationLoding: true,
      requestMsg: ''
    })
    this.sendRequest()
    //   }
    // })
  }

  goResources() {
    history.push('/myapp/resources')
    localStorage.setItem('record', JSON.stringify(this.state.record))
    window.location.reload()
  }
  goInterfacetest() {
    history.push('/myapp/interfacetest')
    localStorage.setItem('record', JSON.stringify(this.state.record))
    window.location.reload()
  }
  oncopy(item) {
    let value = item.sentence
    if (copy(value)) {
      Notification.success({ content: '复制成功!' })
    } else {
      Notification.error({ content: '复制失败!' })
    }
  }
  isputapp = (name, desc) => {
    this.putapp(name, desc)
  }
  putapp(name, desc) {
    let params = {
      id: this.state.record.show_id
    }
    if (desc !== false) {
      params.desc = desc
    } else if (name !== false) {
      params.name = name
    }
    putapp(params).then((res) => {
      if (res.code === 200) {
      } else {
        this.getApiInfo(true)
        Notification.error({ content: res.msg })
      }
    })
  }

  setContinuation = (item) => {
    let tispArr = []
    if (item.prediction_label && item.prediction_label.length > 0) {
      item.prediction_label.forEach((e) => {
        let obj = {}
        if (this.state.emotionData.indexOf(e) === -1) {
          this.state.emotionData.push(e)
          let index = this.state.emotionData.indexOf(e)
          obj = {
            name: e,
            color: COLORS_CUSTOM[index]
          }
        } else {
          let index = this.state.emotionData.indexOf(e)
          obj = {
            name: e,
            color: COLORS_CUSTOM[index]
          }
        }
        tispArr.push(obj)
      })
    }
    let tagsHtml = ''
    tispArr.forEach((e) => {
      tagsHtml += `<div class="rowStart tags-color"><div class="tag-color" style="--bgcolor: ${e.color}"></div>${e.name}</div>`
    })

    let tagslist = `<div class="result-li-tag rowStartWrap">${tagsHtml}</div>`
    let newHTML =
      `<div class="result-li">` + item.original + `</div>${tagslist}`
    let htmls = { __html: newHTML.replaceAll('\n', '<br/>') }
    return <div className="result-ul" dangerouslySetInnerHTML={htmls}></div>
  }

  onChangetitle(type, value) {
    var apiInfo = this.state.apiInfo
    if (type === 'desc') {
      if (value.length > 32) {
        apiInfo.desc = value.substring(0, 32)
        Notification.warning({ content: '修改内容超过32个字！' })
        return
      }
      apiInfo.desc = value
      this.setState({
        apiInfo: apiInfo
      })
      this.isputapp(false, value)
    } else if (type === 'name') {
      if (value.length > 10) {
        apiInfo.name = value.substring(0, 10)
        Notification.warning({ content: '修改标题超过10个字！' })
        return
      }
      apiInfo.name = value
      this.setState({
        apiInfo: apiInfo
      })
      this.isputapp(value, false)
    }
  }
  goaddApp() {
    history.replace('/myapp/addmyapp')
    let state = {
      model_capability: this.state.apiInfo.model_capability,
      checkedtype: this.state.apiInfo.model_id,
      model_id: this.state.apiInfo.model_id,
      name: this.state.apiInfo.model_name
    }
    localStorage.setItem('props', JSON.stringify(state))
    localStorage.removeItem('record')
    window.location.reload()
  }
  addRow() {
    localStorage.removeItem('props')
    localStorage.setItem('record', JSON.stringify(this.state.apiInfo))
    history.replace('/enginefactory/model/management/add')
    window.location.reload()
  }
  setvisibleUpgrade(value) {
    this.setState({
      visibleUpgrade: value
    })
  }
  //获取用户的授权code和授权token
  getUserCode() {
    getAuthorizationCode().then((res) => {
      if (res.code === 200) {
        let code = res.data.code
        getAuthorizationToken({ code }).then((res) => {
          if (res.code === 200) {
            this.setState({
              saasToken: res.data.token
            })
            localStorage.setItem('saastoken', JSON.stringify(res.data.token))
          } else {
            Message.error(res.msg)
          }
        })
      } else {
        Message.error(res.msg)
      }
    })
  }
  handleUpload(option) {
    // upload(option)
    const client = new BosClient({})
    const file = option.file
    const param = {
      type: 'aigc_resume',
      mime: option.file.type || 'application/octet-stream',
      size: option.file.size,
      file: option.file.name
    }
    aigcUpload(param).then((res) => {
      if (res.code == 200) {
        // 配置百度云的配置
        //  console.log(res.data.buck_name,'777');
        this.setState({
          attachment: [res.data.result_url]
        })
        const bosConfig = {
          endpoint: res.data.end_point, // 传入Bucket所在区域域名
          credentials: {
            ak: res.data.accessKeyID, // 您的AccessKey
            sk: res.data.secretAccessKey // 您的SecretAccessKey
          },
          sessionToken: res.data.sessionToken // STS服务器下发的sessionToken
        }
        client.config = bosConfig
        const bucket = res.data.buck_name
        console.log(bucket, res.data.object_key, bosConfig)

        // 定义成功和失败回调
        const done = (response) => {
          // 成功回调
          //  yoo.upload.loading("loading_success", "上传成功");
        }

        const fail = (fail) => {
          // 失败回调
          //  console.log(fail, 'err');
          //  yoo.common.notice(fail.message);
          //  yoo.upload.loading("loading_fail", "上传出错");
        }

        // 开始上传
        client
          .putObjectFromBlob(bucket, res.data.object_key, file)
          .then(done)
          .catch(fail)

        // 监听上传进度
        client.on('progress', function (evt) {
          if (evt.lengthComputable) {
            let percentageValue = parseInt((evt.loaded / evt.total) * 100 + '')
            //  console.log('上传中，已上传了' + percentageValue + '%');
          }
        })
      }
    })
  }
  setFile(fileList, file) {
    this.setState({
      fileList: fileList
    })
    if (file.status === 'done') {
      let key = []
      let fileList = this.state.fileList
      fileList.forEach((item, index) => {
        key.push(item.response.fileKey)
      })
      this.setState({
        attachment: key,
        fileList: fileList
      })
    }
  }
  beforeUpload(file) {
    var AllImgExt = '.jpg|.pdf|.png|.docx|.doc|.jpeg'
    var extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase() //（把路径中的所有字母全部转换为小写）
    if (AllImgExt.indexOf(extName + '|') === -1) {
      let ErrMsg =
        '该文件类型不允许上传。请上传 .csv类型的文件，当前文件类型为' + extName
      Message.error(ErrMsg)
      return false
    }
    const isLt10M = !(
      b2ValueUnit(file.size)[1] === 'B' ||
      b2ValueUnit(file.size)[1] === 'KB' ||
      (b2ValueUnit(file.size)[1] === 'MB' && b2ValueUnit(file.size)[0] <= 5)
    )
    return new Promise((resolve, reject) => {
      if (isLt10M) {
        Message.error('上传文件不能大于5MB')
        reject()
      } else {
        resolve()
      }
    })
  }
  render() {
    const {
      visibleUpgrade,
      upgradetips,
      apiInfo,
      versions,
      input_describe,
      ParagraphContinuation,
      ContinuationLoding,
      TextAreaValue,
      jobTitle,
      optionVlue,
      requestMsg,
      requestMsgText,
      fileList,
      chatpptSrc
    } = this.state
    return (
      <div className="product-emotionClass">
        <div id="renderHeaders">
          <div className="GroupTable-fixe GroupTable-fixe-end">
            {/* <div className="edit-title">
              <div className="Header-init">
                <div className="Header-title">
                  <Typography.Paragraph
                    className="Header-uptitle"
                    editable={
                      apiInfo.type === 0
                        ? null
                        : {
                            onChange: this.onChangetitle.bind(this, 'name')
                          }
                    }
                  >
                    {apiInfo.name}
                  </Typography.Paragraph>
                </div>
              </div>
              <div className="Header-upParagraph">
                <Typography.Paragraph
                  className="Header-uptitle"
                  editable={
                    apiInfo.type === 0
                      ? null
                      : {
                          onChange: this.onChangetitle.bind(this, 'desc')
                        }
                  }
                >
                  {apiInfo.desc}
                </Typography.Paragraph>
              </div>
            </div> */}
            <Title params={apiInfo} />
            <Space size={'medium'} align="center">
              {apiInfo.type === 0 ? (
                <Button
                  className="primarybtn custom-White-button"
                  onClick={this.goaddApp.bind(this)}
                >
                  保存应用
                </Button>
              ) : (
                <>
                  <Button
                    style={
                      {
                        // display:
                        //   this.state.identity &&
                        //   this.state.identity !== 'PERSONAL'
                        //     ? 'inline-block'
                        //     : 'none',
                      }
                    }
                    shape="circle"
                    className="custom-White-button"
                    onClick={this.goInterfacetest.bind(this)}
                  >
                    接口调用
                  </Button>
                </>
              )}
            </Space>
          </div>
        </div>
        <Layout className="semanticprototype-Layout" id="layout_id">
          <Sider className="Sider-left">
            <div className="upload-file">
              <div className="upload-file-title Continuation-input-title">
                导入简历
              </div>
              <div>
                <Upload
                  accept=".pdf,.doc,.docx,.jpg,.png,.jpeg,.PNG"
                  fileList={fileList}
                  renderUploadList={this.renderUploadList}
                  limit={1}
                  onChange={this.setFile.bind(this)}
                  customRequest={(option) => {
                    this.handleUpload(option)
                  }}
                  beforeUpload={this.beforeUpload.bind(this)}
                  onExceedLimit={() => {
                    Message.warning('超过上传数量限制！最多上传1个')
                  }}
                >
                  <div className="rowCenter trigger">
                    <span className="iconfont icon-icon_chuangjian_24"></span>
                    <div>点击此处上传文件</div>
                  </div>
                </Upload>
                {/* <div className="Upload-pictures-tip">
                  （仅支持.pdf格式，最大文件尺寸5MB）
                </div> */}
              </div>
            </div>
            <div
              className="Sider-left-configure columnSpaceBetween"
              style={{ backgroundColor: '#fff' }}
              id="globalModleBox"
            >
              <div
                className="Continuation-input Continuation-input-resume"
                style={{ height: '130px', marginBottom: '20px' }}
              >
                <div
                  className="Continuation-input-title"
                  style={{ padding: '12px 12px 0 12px' }}
                >
                  岗位名称
                </div>
                <Input
                  placeholder={'请输入岗位名称'}
                  style={{
                    width: '100%',
                    backgroundColor: 'transparent',
                    borderRadius: '8px',
                    minHeight: '40px',
                    marginTop: '7px'
                  }}
                  value={jobTitle}
                  onChange={this.onTitle.bind(this)}
                />
              </div>
              <div className="Continuation-input Continuation-input-resume">
                <div
                  className="Continuation-input-title"
                  style={{ padding: '12px 12px 0 12px' }}
                >
                  岗位JD
                </div>
                <TextArea
                  placeholder={input_describe}
                  style={{ width: '100%' }}
                  value={TextAreaValue}
                  onChange={this.onTextArea.bind(this)}
                />
              </div>
            </div>
            <div className="Upload-pictures-bottom">
              <Button
                type="primary"
                className="Start-generation"
                loading={false}
                onClick={this.ChangeAbatch.bind(this, 'start')}
              >
                开始分析
              </Button>
            </div>
          </Sider>
          <Content>
            <div className="experience-result" id="result">
              <div id="result_title" className="rowSpaceBetween result_title">
                <Typography>生成结果</Typography>
                <Typography.Paragraph className="result-remarks">
                  (内容基于韦尼克AI创作引擎生成，仅供参考)
                </Typography.Paragraph>
              </div>
              {(ParagraphContinuation && ParagraphContinuation.length > 0) ||
              ContinuationLoding ? (
                <div className="Paragraph-generate" style={{ height: '100%' }}>
                  {ContinuationLoding ? (
                    <Empty
                      className="Continuation-loding"
                      icon={<img src={Generating_img} alt="" />}
                      description={
                        <Typography
                          style={{
                            color: '#4e5969',
                            marginTop: 21,
                            fontSize: 16
                          }}
                        >
                          正在生成中...
                        </Typography>
                      }
                    />
                  ) : (
                    // {
                    //   token  ?
                    <iframe
                      src={chatpptSrc}
                      className={`semanticprototype-Layout sass-semanticprototype-Layout`}
                      id="layout_id"
                      style={{ height: '100%' }}
                    ></iframe>
                    //   :
                    //   <div className='iframe-loading'>
                    //     <Spin size={60}/>
                    //   </div>
                    // }

                    // <div className="result-list">
                    //   {ParagraphContinuation.length > 0 ? (
                    //     <>
                    //       {ParagraphContinuation.map((item, i) => {
                    //         return (
                    //           <div key={i}>{this.setContinuation(item)}</div>
                    //         )
                    //       })}
                    //     </>
                    //   ) : null}
                    // </div>
                  )}
                </div>
              ) : requestMsg === 'error' ? (
                <Empty
                  className="Continuation-Empty Empty-error"
                  imgSrc={errorIcon}
                  description={
                    <Space direction="vertical">
                      <Typography
                        style={{
                          color: '#4e5969',
                          marginTop: 30,
                          fontSize: 16
                        }}
                      >
                        抱歉，服务器生成错误
                      </Typography>
                      <Typography style={{ color: '#4e5969', fontSize: 16 }}>
                        可尝试
                        <span
                          style={{ color: '#406EFF', cursor: 'pointer' }}
                          onClick={this.ChangeAbatch.bind(this)}
                        >
                          重新生成
                        </span>
                      </Typography>
                    </Space>
                  }
                />
              ) : (
                <Empty
                  className="Continuation-Empty Empty-none"
                  imgSrc={Emptydata_img}
                  description={
                    <Space direction="vertical">
                      <Typography
                        style={{
                          color: '#4e5969',
                          marginTop: 30,
                          fontSize: 16
                        }}
                      >
                        暂无生成结果
                      </Typography>
                      <Typography style={{ color: '#4e5969', fontSize: 16 }}>
                        {requestMsgText}
                      </Typography>
                    </Space>
                  }
                />
              )}
            </div>
          </Content>
        </Layout>
        <UpgradeTips
          visible={visibleUpgrade}
          notification_status={upgradetips?.notice_type}
          notification_message={upgradetips?.message}
          model_capability={upgradetips?.model_capability}
          onCancel={() => this.setvisibleUpgrade(false)}
        ></UpgradeTips>
      </div>
    )
  }
}
export default EmotionClass
